import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FileItem } from '@models/file-item.model';
import { Invoice } from '@models/invoice.model';
import { PurchaseOrderDto } from '@app/models/purchase-order.model.dto';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FileService } from '@services/file.service';
import { InvoiceService } from '@services/invoice.service';
import { Toaster } from '@services/toaster.service';
import { LocalStorage } from 'ngx-webstorage';
import { RejectionReasonModalComponent } from '@app/shared/modals/rejection-reason-modal/rejection-reason-modal.component';

@Component({
  selector: 'ngx-po-invoice-detail',
  templateUrl: './po-invoice-detail.component.html',
  styleUrls: ['./po-invoice-detail.component.scss'],
})
export class PoInvoiceDetailComponent implements OnInit {
  @LocalStorage() organizationId;
  @Input() companyType: string;
  @Input() invoice: Invoice;
  @Input() purchaseOrder: PurchaseOrderDto;

  @Output() invoiceUpdated: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    public activeModal: NgbActiveModal,
    private invoiceService: InvoiceService,
    private fileService: FileService,
    private $toaster: Toaster,
    private $modal: NgbModal,
  ) { }

  ngOnInit() {
  }

  getFile(file: FileItem) {
    this.invoiceService.getInvoiceFile(this.organizationId, this.purchaseOrder.id, this.invoice.id, this.invoice.file.file_id)
      .subscribe((res) => {
        file.file_name.endsWith('.pdf') ?
          this.fileService.viewPdf(res, file.file_name) :
          this.fileService.downloadBlobFile(res, file.file_name);
      });
  }

  updateInvoiceDetail() {
    this.invoiceService.getInvoice(this.organizationId, this.purchaseOrder.id, this.invoice.id)
      .subscribe((invoiceData) => {
        this.invoice = invoiceData;
      });
  }

  acceptOrRejectInvoice(invoice: Invoice, accepted: boolean) {
    if (!accepted) {
      setTimeout(() => {
        this.$modal.open(RejectionReasonModalComponent, {
          size: 'sm',
          container: 'nb-layout',
          keyboard: false,
          windowClass: 'rejection-reason-modal',
        }).result
          .then((result: any) => {
            if (result) {
              invoice.rejection_reason = result.reason;
              this.invoiceService.rejectInvoiceWithReason(this.organizationId, this.purchaseOrder.id, invoice.id, result.reason)
                .subscribe(async (res) => {
                  this.$toaster.show('success', 'Invoice', 'Invoice rejected');
                  this.updateInvoiceDetail();
                  this.invoiceUpdated.emit(this.invoice.id);
                }, (error) => {
                  const errMsg = !!error.error && !!error.error.detail ? error.error.detail : error.message;
                  this.$toaster.show('error', 'Reject Invoice', 'Couldn\'t reject invoice, please try again later.');
                });
            }
          });
      });
    } else {
      this.invoiceService.acknowledgeInvoice(this.organizationId, this.purchaseOrder.id, invoice.id, true)
        .subscribe(async (res) => {
          this.$toaster.show('success', 'Invoice', 'Invoice accepted');
          this.updateInvoiceDetail();
          this.invoiceUpdated.emit(this.invoice.id);
        }, (error) => {
          const errMsg = !!error.error && !!error.error.detail ? error.error.detail : error.message;
          this.$toaster.show('error', 'Approve Invoice', 'Couldn\'t approve invoice, please try again later.');
        });
    }
  }
}
